import React, { useState } from "react";
import * as R from "ramda";
import classNames from "classnames";
import CSSModules from "react-css-modules";
import { Div, CheckIcon, SmallCheckbox } from "components/Base";
import { FIELD_TAB_ALL, FIELD_TAB_GLOBAL, FIELD_TAB_EVENT } from "../constants";
import LanguageInfo from "./LanguageInfo";
import LanguageIcon from "./LanguageIcon";
import css from "./styles.scss";
// import { connect } from "react-redux";
// import { getters } from "EventLight/Sessions/SelectScheduleFieldsModal";

const decorate = R.compose(CSSModules(css));

const FieldNode = ({ field, toggleSelectedField, selected }) => {
  return (
    <Div
      key={field.id}
      p={2}
      display="row.flex-start.center"
      bra={1}
      className={css.fieldNode}
      mt={1}
      onClick={
        field.is_auto_enabled
          ? undefined
          : () =>
              toggleSelectedField({
                selected,
                name: field.name,
                is_auto_enabled: field.is_auto_enabled,
                fieldId: field.id,
                is_report_field: field.is_report_field
              })
      }
    >
      {field.is_auto_enabled ? (
        <CheckIcon color="primary7" ml={1} mr={1} />
      ) : (
        <SmallCheckbox selected={selected} />
      )}
      <div>
        <Div fw={3} fs={2} ml={1} color="gray7" display="block">
          {field.name}
        </Div>
        <Div
          display="row.flex-start.center"
          fw={2}
          fs={1}
          ml={1}
          color="gray6"
          style={{ textTransform: "capitalize" }}
        >
          {field.type}{" "}
          {field.override && field.original_name !== field.name
            ? `(${field.original_name})`
            : ""}
          <LanguageInfo field={field} />
          {field?.settings?.isTranslatedField ? (
            <Div display="row.flex-start.center">
              <LanguageIcon />
              &nbsp;{field.settings.parentFieldName} (
              <span
                style={{
                  textTransform: "lowercase"
                }}
              >
                {field.settings.translatedLanguage})
              </span>
            </Div>
          ) : null}
        </Div>
      </div>

      {field.event_id ? (
        <span
          style={{ marginLeft: "auto", fontSize: 15 }}
          className="material-icons-outlined"
        >
          event
        </span>
      ) : (
        <span
          style={{ marginLeft: "auto", fontSize: 15 }}
          className="material-icons-outlined"
        >
          language
        </span>
      )}
    </Div>
  );
};

const FieldsListTabs = ({
  toggleSelectedField,
  allFields,
  selectedFields,
  category,
  showScopeTabs = true
}) => {
  const [selectedTab, setSelectedTab] = useState(FIELD_TAB_ALL);
  const globalFields = R.filter(f => !f.event_id, allFields);
  const eventFields = R.filter(f => f.event_id, allFields);

  const getFields = fields => {
    return R.map(field => {
      const selected = R.any(R.propEq("id", field.id), selectedFields);

      return (
        <FieldNode
          key={field.id}
          field={field}
          toggleSelectedField={toggleSelectedField}
          selected={selected}
        />
      );
    }, fields);
  };

  const showTabs = !R.prop("is_report_category", category);
  const avoidEmptyTabs = eventFields.length > 0;

  return showScopeTabs && showTabs ? (
    <div styleName="fieldsListTab">
      <div className="field-type-tabs-controls">
        <div
          className={classNames({
            "tab-selected": selectedTab === FIELD_TAB_ALL
          })}
          onClick={() => setSelectedTab(FIELD_TAB_ALL)}
        >
          All Fields
        </div>
        {avoidEmptyTabs && (
          <div
            className={classNames({
              "tab-selected": selectedTab === FIELD_TAB_GLOBAL
            })}
            onClick={() => setSelectedTab(FIELD_TAB_GLOBAL)}
          >
            <span style={{ fontSize: 14 }} className="material-icons-outlined">
              language
            </span>{" "}
            Global
          </div>
        )}
        {avoidEmptyTabs && (
          <div
            className={classNames({
              "tab-selected": selectedTab === FIELD_TAB_EVENT
            })}
            onClick={() => setSelectedTab(FIELD_TAB_EVENT)}
          >
            <span style={{ fontSize: 14 }} className="material-icons-outlined">
              event
            </span>{" "}
            Event
          </div>
        )}
      </div>

      <div>
        {selectedTab === FIELD_TAB_ALL && getFields(allFields)}
        {selectedTab === FIELD_TAB_GLOBAL && getFields(globalFields)}
        {selectedTab === FIELD_TAB_EVENT && getFields(eventFields)}
      </div>
    </div>
  ) : (
    <div>{getFields(allFields)}</div>
  );
};

export default decorate(FieldsListTabs);
